{
  "translation": {
    "activities": {
      "transport_detail": {
        "call_driver": "Call driver",
        "need_support": "Need support?",
        "no_trip": "You don't have any trip yet.",
        "phone": {
          "description": "Do you want to call",
          "title": "Help via phone"
        },
        "title": "Ride details",
        "cancelled_trip_reason_title": "Trip not completed",
        "cancelled_trip_reason_description": "You can rebook to continue the trip",
        "rebook": "Rebook",
        "book_return": "Book return"
      }
    },
    "auth": {
      "complete_register": {
        "done": "Done",
        "email_description": "Enter your email to make account more secured.",
        "full_name": "Full Name",
        "referral_code": "Referral code",
        "referral_code_description": "If you got a referral code from your friend, please put here.",
        "title": "Complete registration"
      },
      "login": {
        "confirmation": "By continuing, you agree to be's <1>Marketplace Regulations</1>, <3>Personal Data Protection Policy</3> and <5>Transportation Service Contract</5>.",
        "or_login_with": "Or sign in with",
        "subtitle": "Sign up or log in to your <0>be</0> account now",
        "title": "Ride with be"
      },
      "otp": {
        "description": "A verification code will be sent to <1>{{phoneNumber}}</1>. Please check your messages and enter the verification code here.",
        "resend_otp": "Resend verification code",
        "resend_otp_in": "Resend verification code ({{time}})",
        "title": "Enter OTP code"
      },
      "password": {
        "description": "You are logging in with the phone number",
        "error": "Incorrect password.",
        "forgot_password": "Forgot password",
        "title": "Enter your password"
      },
      "placeholder": {
        "phone_number": "Your phone number"
      },
      "session": {
        "expired_message": "Your session has expired. Please login again."
      },
      "validation": {
        "email": "Not a valid email address.",
        "phone_number": "Please enter a valid phone number.",
        "required": "Required."
      }
    },
    "be": "be",
    "chat": {
      "input": {
        "placeholder": "Aa"
      },
      "message": {
        "sent": "Sent"
      }
    },
    "common": {
      "add": "Add",
      "app_name": "be",
      "around": "About",
      "back": "Back",
      "call": "Call",
      "cancel": "Cancel",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "cash": "Cash",
      "close": "Close",
      "collapse": "Collapse",
      "confirm": "Confirm",
      "continue": "Continue",
      "delete": "Delete",
      "done": "Done",
      "exit": "Exit",
      "got_it": "Got it",
      "hide": "Hide",
      "i_got_it": "I got it",
      "language": {
        "en": "English",
        "vi": "Tiếng Việt"
      },
      "loading": "Loading",
      "login_with": "Sign in with",
      "non_supported": {
        "description": "This service is not yet supported on the current version. Please use the be app.",
        "payment": "Link this payment method is not yet supported on the current version. Please use the be app.",
        "title": "Not available"
      },
      "non_supported_session": {
        "description": "You cannot view this ride in the current version. Please use the be app to track the information.",
        "title": "Trips' Information"
      },
      "ok": "OK",
      "password": "password",
      "payment": "Payment",
      "reply": "Reply",
      "required": "Required",
      "reselect": "Reselect",
      "ride_contract": "Ride contract",
      "save": "Save",
      "scroll_to_top": "Back to top",
      "see_less": "See less",
      "see_more": "See more",
      "send": "Send",
      "show": "Show",
      "support": "Need help",
      "term_and_condition": "Terms and Conditions",
      "time": {
        "hour": "hours",
        "min": "minutes"
      },
      "try_again": "Try again",
      "use": "Use coupon",
      "version": "Version",
      "view_all": "View all"
    },
    "food_action_agree": "Yes",
    "food_action_create_new_order": "Create new order",
    "food_action_create_new_order_with_no": "No, create new order",
    "food_action_keep_order": "Keep order",
    "food_action_rate": "Rate",
    "food_cancel_order_title": "Reason for cancellation",
    "food_cart_additem_title": "Add to cart",
    "food_cart_empty_desc": "Let <1>be</1> fill your empty stomach!",
    "food_cart_empty_modal_message": "Please go back to the restaurant screen to update the cart",
    "food_cart_empty_modal_title": "Your cart is empty",
    "food_cart_empty_title": "Your cart is empty",
    "food_cart_explore_now": "Explore now",
    "food_cart_title": "My cart",
    "food_cart_updateitem_title": "Update cart",
    "food_change_location": "Change location",
    "food_checkout_action_add_item": "Add dish",
    "food_checkout_action_order": "Confirm",
    "food_checkout_deliver_to": "Deliver to",
    "food_checkout_error_content": "Sorry, your promotion can't apply. Do you want to deselect invalid promotional code before checkout or re-select a new promotional code?",
    "food_checkout_error_title": "Invalid promo code",
    "food_checkout_fee_delivery": "Delivery fee",
    "food_checkout_fee_doorstep": "Delivery to door",
    "food_checkout_fee_insurance": "Food Insurance",
    "food_checkout_fee_parking": "Parking fee",
    "food_checkout_fee_process": "Extra fee",
    "food_checkout_fee_small_order": "Small fee",
    "food_checkout_fee_total": "Applied fee",
    "food_checkout_note": "Note",
    "food_checkout_note_input_title": "Note",
    "food_checkout_order": "Order",
    "food_checkout_order_cancel": "Cancel",
    "food_checkout_order_item": "item",
    "food_checkout_order_sending": "Sending order...",
    "food_checkout_paid_by": "Paid by",
    "food_checkout_promotion": "Promotion",
    "food_checkout_promotion_action_apply": "Apply",
    "food_checkout_promotion_selected": "{{amount}} promos selected",
    "food_checkout_promotion_skip": "Continue without promotion",
    "food_checkout_temporary_price": "Food amount",
    "food_checkout_title": "Checkout",
    "food_checkout_toll_fee": "Toll fee",
    "food_checkout_total_price": "Total Amount",
    "food_common_item_like_one": "like",
    "food_common_item_like_other": "likes",
    "food_common_item_sold_one": "order",
    "food_common_item_sold_other": "orders",
    "food_common_pieces_one": "item",
    "food_common_pieces_other": "items",
    "food_editaddress_title": "Recipient",
    "food_estimated_delivery_time": "Estimated delivery",
    "food_finish_title": "Thank you for choosing Be",
    "food_home_deliveryto_title": "Deliver to",
    "food_home_goodrestonearby_title": "Nearby delicious restaurants",
    "food_home_location_determining": "Locating...",
    "food_home_search_placeholder": "Search for dish or restaurant",
    "food_intrip_action_view_route": "View route",
    "food_intrip_order_cancelled": "Order has been canceled",
    "food_intrip_order_detail": "Order detail",
    "food_not_support_location": "Currently be is not available in your area. Please choose a new address or try again later.",
    "food_order_action_cancel": "Cancel order",
    "food_order_action_cancel_order": "Cancel order",
    "food_order_action_cannot_cancel_detail": "Why can't I cancel my order",
    "food_order_cannot_cancel_title": "The dish is being prepared by the restaurant, so you cannot cancel this order. Please wait a moment.",
    "food_order_cart_action_delete_all": "Delete all",
    "food_order_cart_action_view_order": "Checkout",
    "food_order_cart_note_for_resto": "Note for restaurant",
    "food_order_cart_title": "Cart",
    "food_order_delivered": "Delivered",
    "food_order_desc_waiting_for_confirmation_desc": "will sent you information after the order is confirmed.",
    "food_order_desc_waiting_for_confirmation_title": "Orders are being prepared",
    "food_order_desc_waiting_for_driver": "will sent you information when a suitable driver is found",
    "food_order_detail": "Order Detail",
    "food_order_detail_distance": "Distance",
    "food_order_id": "Order ID",
    "food_order_not_delivered": "Not delivery yet",
    "food_order_quantity_edit_title": "Amount",
    "food_order_view_detail_button": "View order detail",
    "food_promo_input_placeholder": "Enter promo code",
    "food_promo_input_submit": "Use coupon",
    "food_promo_merchant_applied_max": "You can apply up to {{count}} time",
    "food_promo_merchant_applied_resto": "List applied restaurants",
    "food_promo_merchant_description": "Other information",
    "food_promo_merchant_discount_amount": "Apply promotion {{amount}} up to {{upto}}",
    "food_promo_merchant_discount_amount_without_percent": "Apply promotion {{amount}}",
    "food_promo_merchant_max_order_value": "Maximum order value to apply promotion",
    "food_promo_merchant_min_order_value": "Minimum order value to apply promotion",
    "food_promo_merchant_payment_method": "Payment method",
    "food_promo_not_applicable": "Not applicable to selected promo.",
    "food_promo_not_eligible": "Promo is not eligible to apply.",
    "food_promo_view_more": "View more {{amount}} promos",
    "food_rating_driver_desc": "How do you rate your driver?",
    "food_rating_driver_input_placeholder": "Sharing your experience",
    "food_rating_driver_title": "Rate your driver",
    "food_rating_order_detail_title": "Order detail",
    "food_rating_restaurant_desc": "How do you rate your food experience at {{restaurantName}}?",
    "food_rating_restaurant_title": "Rate restaurant",
    "food_rating_resto_item_title": "How was your food order?",
    "food_rating_resto_title": "Review dishes and restaurant",
    "food_restaurant_lists": "List of all restos",
    "food_resto_cart_action_delete_cart_message": "Are you sure you want to delete all the items in the cart?",
    "food_resto_cart_action_delete_cart_title": "Delete cart",
    "food_resto_detail_open_at": "Open at {{time}} on {{date}}",
    "food_resto_detail_review": "ratings",
    "food_resto_item_choose_limit_max": "Select max {{num}}",
    "food_resto_item_choose_limit_min": "Select min {{num}}",
    "food_resto_item_no_reviews": "No ratings",
    "food_resto_item_not_available": "Sold out",
    "food_resto_item_note_placeholder": "Add your request for this item.",
    "food_resto_item_note_title": "Note for restaurant",
    "food_resto_minimum_order_value": "Minimum order value",
    "food_resto_new_restaurant": "New restaurant",
    "food_resto_open_at": "Open at",
    "food_resto_required_message": "Please select the required items",
    "food_resto_search_no_result_message": "Try different keyword or search in other restaurant",
    "food_resto_search_no_result_title": "No result found",
    "food_resto_search_placeholder": "Search for dishes at",
    "food_resto_view_all_store": "View all {{count}} restaurants",
    "food_search_before_desc": "Feeling hungry? Order food now.",
    "food_search_before_title": "Delicious dishes are waiting for you",
    "home": {
      "activities": {
        "subtitle": "Activities",
        "tabs": {
          "delivery": "Delivery",
          "food": "Food",
          "transport": "Transport"
        },
        "title": "Activities"
      },
      "input_dropoff": "Where do you want to go?",
      "input_dropoff_loading": "Finding your location...",
      "other_services": "Others",
      "request_location": {
        "actions": {
          "allow": "Allow to use location",
          "edit_location": "Manually input location"
        },
        "declined": "Be need your location to work correctly. Please input your location manually below.",
        "description": "Please let us know your location. We do this to improve pickups, drop-offs, customer services and your safety.",
        "error": "Error while getting your location. Please manually input it."
      },
      "rewards": {
        "subtitle": "Rewards",
        "title": "Rewards"
      },
      "welcome": "Hi, {{name}}"
    },
    "loading": "Loading",
    "location_add_home": "Add home",
    "location_add_other": "Add location",
    "location_add_work": "Add work",
    "location_home": "Home",
    "location_work": "Work",
    "login_password_wrong_attempts_message": "Incorrect password. You have {{remain}} attempts remaining.",
    "payment_methods": {
      "title": "Payment Methods"
    },
    "payment_try_another_method": "Try other payment method",
    "permission_granted": "Granted",
    "permission_name_avatar": "Name and avatar (from Zalo)",
    "permission_name_avatar_desc": "Used to identify and access features from Zalo (required)",
    "permission_phone_number": "Phone number",
    "permission_phone_number_desc": "Used to identify and contact with drivers.",
    "permission_open_settings": "Manage app permissions",
    "permission_zalo_required": "Be needs to access to name and avatar from Zalo for working properly.",
    "promotions": {
      "coupons": {
        "actions": {
          "use_later": "Use later",
          "use_now": "Use now"
        },
        "expired_at": "Valid until"
      },
      "detail": {
        "title": "Promotion detail"
      },
      "input_placeholder": "Enter promo code",
      "title": "Promotion"
    },
    "require_permission_location_description": "be needs location information to be able to suggest available services in your area.",
    "require_permission_location_title": "be needs your location",
    "require_permission_phonenumber_description": "Your phone number will be used to identify and receive notifications from be.",
    "require_permission_phonenumber_title": "be need your phone number",
    "ride": {
      "cancel_trip": {
        "form": {
          "other": {
            "title": "Please type the reason"
          }
        },
        "reasons": {
          "title": "Ride cancellation"
        },
        "submit": "Cancel ride"
      },
      "common": {
        "book_long_ride": "Book",
        "book_ride": "Book",
        "drop_off": "Destination",
        "pick_from_map": "Set on map",
        "pick_up": "Pickup point",
        "saved_locations": "Saved locations",
        "suggested_addresses": "Suggestions for you",
        "user_location": "Select a location"
      },
      "confirm_address": {
        "actions": {
          "confirm": "Confirm pickup location"
        },
        "placeholder": {
          "note": "Note for driver"
        }
      },
      "contract": {
        "address": "Address",
        "be": "BE GROUP Joint Stock Company",
        "birth_year": "Birth year",
        "customer_information": "Customer information",
        "customer_name": "Customer name",
        "description": "Specific terms of be's contract",
        "distance": "Distance",
        "driver_information": "Driver information",
        "driver_name": "Driver name",
        "dropoff_location": "Destination",
        "end_time": "End time",
        "license_plate_number": "License plate number",
        "number_of_seats": "Number of seats",
        "passenger_information": "Passenger information",
        "passenger_name": "Passenger name",
        "passenger_one": "passenger",
        "passenger_other": "passengers",
        "payment": "Payment",
        "phone_number": "Phone number",
        "pickup_location": "Pickup location",
        "start_time": "Start time",
        "tax_number": "Tax number (if available)",
        "title": "Contract",
        "trip_information": "Trip information",
        "vehicle_information": "Vehicle information"
      },
      "fare": {
        "error": {
          "cannot_use_promo_code": {
            "title": "Booking with no promotion"
          },
          "trip_radius_too_short": {
            "description": "Your trip is too short, please choose a further destination."
          }
        },
        "option": {
          "form": {
            "invoice": {
              "company_address": {
                "label": "Company address",
                "placeholder": "Input company address",
                "validation": "Required"
              },
              "company_name": {
                "label": "Company name",
                "placeholder": "Input company name",
                "validation": "Required",
                "validation22": "Required"
              },
              "description": "Apply for Cash and Card only.",
              "email": {
                "label": "Email",
                "placeholder": "Input email",
                "validation": "Email is not valid"
              },
              "label": "Issue an invoice",
              "success": "Success",
              "tax_code": {
                "label": "Tax code",
                "placeholder": "Input tax code",
                "validation": "Tax code is not valid"
              },
              "title": "I need e-invoice"
            },
            "note": {
              "label": "Note for driver",
              "placeholder": "Input note"
            },
            "validation": {
              "email": "Not a valid email address.",
              "required": "Required.",
              "tax_code": "Tax Code is not valid."
            }
          },
          "invoice": {
            "title": "Invoice Information"
          },
          "title": "Option"
        }
      },
      "in_trip": {
        "actions": {
          "cancel": "Cancel",
          "cancel_booking": "Cancel booking",
          "normal_call": "Call",
          "text": "Message"
        },
        "info": {
          "cost": "Cost",
          "distance": "Distance",
          "drop_off_another": "Drop off another",
          "engagement_id": "Trip ID",
          "fare": "Trip fare",
          "insurance": "Trip insurance",
          "paid_by": "Paid by",
          "paid_in": "Paid in",
          "payment": "Payment",
          "promotion": "Promotion",
          "time": "ETA",
          "tip": "Tip for driver",
          "addi": "Extra fee",
          "total_amount": "Total",
          "trip_detail": "Trip detail",
          "waiting_time": "Waiting time",
          "with_invoice": "E-Invoice"
        },
        "status": {
          "finding_driver": "Finding your driver...",
          "no_drivers_description": "Please try again later.",
          "no_drivers_title": "All drivers are busy"
        }
      },
      "rate_driver": {
        "description": "How you rate your driver ?",
        "feedback_placeholder": "Please share your thinking",
        "subtitle": "Rate the driver",
        "thank_you": "Thank you for rating the driver.",
        "title": "Thank you for choosing be"
      },
      "select_address": {
        "placeholder": {
          "current_address": "Enter current location",
          "drop_off": "Enter destination",
          "pick_up": "Enter pickup location",
          "recipient": "Recipient",
          "save_location": "Enter location"
        }
      },
      "trip_status": {
        "accepted": "Driver is arriving",
        "arrived": "Driver has arrived",
        "cancelled_by_driver": "Reason: Cancelled by driver.",
        "finding_driver": "Finding a driver...",
        "order_cancelled": "Your trip was cancelled",
        "perfect_ride": "Driver is dropping off then arriving",
        "started": "On trip"
      }
    },
    "ride_confirmaddress_notefordriver_input_title": "Note for driver",
    "ride_promotion_other_promo_title": "Other deals",
    "ride_promotion_user_promo_title": "Don't miss your good deals",
    "ride_save_address_form_field_address_label": "Address",
    "ride_save_address_form_field_name_label": "Location name",
    "ride_save_address_form_field_name_placeholder": "Input location name",
    "ride_save_address_form_title": "Confirm location",
    "session_expired_description": "Please login again.",
    "session_expired_title": "Your session has expired.",
    "transport_having_another_trip_desc": "Your trip to {{addr}} is not completed yet, do you want to navigate to in trip screen?",
    "transport_having_another_trip_title": "Having another trip",
    "transport_having_another_trip_cta_1": "View trip detail",
    "transport_having_another_trip_cta_2": "Back to home",
    "session_not_found_title": "This session has been completed or not existed.",

    "transport_rating_engagement_detail_title": "Ride detail",
    "user": {
      "settings": {
        "logout": "Logout",
        "payment": "Payment",
        "promotion": "Promotion",
        "select_language": "Language",
        "title": "Setting"
      }
    },
    "user_support_cta_phone": "Help via phone",
    "user_support_title": "Help",
    "chat_no_message": "No message",
    "verification_title": "Enter verification code",
    "verification_desc": "Please enter the verification code sent to <1>{{phoneNumber}}</1> to access this page.",
    "resend_otp": "Resend OTP",
    "resend_otp_in": "Resend OTP ({{countdown}})",
    "unexpected_error": "An unexpected error occurred. Please try again.",
    "verification_sending_otp": "Sending verification code...",
    "verification_retrying_otp": "Retrying ({{attempt}}/{{max}})...",
    "verification_send_failed_title": "Unable to send verification code",
    "verification_send_failed_desc": "We couldn't send a verification code to your phone number. Please check your network connection and try again.",
    "verification_send_failed_support": "If the problem persists, contact <1>hotline 1900232345</1> for support.",
    "verification_try_again": "Try again",
    "verification_go_back": "Go back",
    "verification_resend_failed": "Unable to resend the code. Please try again later.",
    "wrong_otp": "Incorrect OTP. Please try again.",
    "ride_select_payment_method": "Select payment method",
    "input_location": "Input location",
    "common_next": "Next",
    "unauthorized_title": "Uh oh, seem like you are not authorized to access this page.",
    "unauthorized_title_partner": "Uh oh, seem like your session has expired. Please access be again from {{partnerName}} to continue using.",
    "transport_book_now": "Book now",
    "detail": "View detail",
    "transport_return_book": "Book return",
    "transport_rebook": "Rebook",
    "promo_use": "Use",
    "promo_deselect": "Remove",
    "ride_finding_driver_title": "Finding driver for you",
    "ride_current_pickup": "Current pickup location",
    "ride_payment_failed": "Payment failed",
    "ride_payment_failed_desc_debt": "Please pay your outstanding balance of <1>{{amount}}</1> through the be app.",
    "tap_to_see_more": "Tap to see more",
    "choose_from_map_title_pickup": "Choose pickup location",
    "choose_from_map_title_dropoff": "Choose dropoff location",
    "choose_from_map_desc_pickup": "Confirm or change your pickup location",
    "choose_from_map_desc_dropoff": "Confirm or change your dropoff location"
  }
}
